import { Atom } from 'AppReact';
import { CSVLink } from "react-csv";

export default Atom({ type: 'custom', dataType: 'string', template: CSVLink })